import { useState, useEffect } from 'react'
import listFunction from './crudFunctions/listFunction'
import { payment, paymentListResponse } from '../interfaces'
import PayDetailModal from './modals/PayDetailModal'
import PaySearchModal from './modals/PaySearchModal'
import GenerateFileModal from './modals/GenerateFileModal'
import PaymentsList from './components/PaymentsList'
import assets from './crudFunctions/assets'

const Payments = () => {
  const [showPaySearchModal, setShowPaySearchModal] = useState<boolean>(false)
  const [showFileModal, setShowFileModal] = useState<boolean>(false)
  const [showDetailModal, setShowDetailModal] = useState<boolean>(false)
  const [payments, setPayments] = useState<payment[] | null>(null)
  const [next, setNext] = useState<null | string>(null)
  const [previous, setPrevious] = useState<null | string>(null)
  const [singlePayment, setSinglePayment] = useState<null | payment>(null)

  const endpoint: string = 'payment/list/'
  const listUrl: string = assets.apiUrl + endpoint

  const nextPage = (): void => {
    listFunction(next!).then((response: paymentListResponse) => {
      setPayments(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    })
  }

  const previousPage = (): void => {
    listFunction(previous!).then((response: paymentListResponse) => {
      setPayments(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    })
  }

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const response = await listFunction(listUrl)

      setPayments(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    }
    fetchData()
  }, [listUrl])

  return (
    <>
      <div className='grid grid-cols-2'>
        <button
          className='bg-viper justify-self-end text-white text-3xl px-3 py-2 shadow-lg mt-3'
          onClick={() => setShowPaySearchModal(true)}>
          Buscar Pago
        </button>
        <button
          className='bg-viper justify-self-start  text-white text-3xl px-3 py-2 shadow-lg mt-3 ml-7'
          onClick={() => setShowFileModal(true)}>
          Generar Archivo
        </button>
      </div>

      {showPaySearchModal && (
        <PaySearchModal
          setShowPaySearchModal={setShowPaySearchModal}
          setShowDetailModal={setShowDetailModal}
          showDetailModal={showDetailModal}
          setSinglePayment={setSinglePayment}
          singlePayment={singlePayment}
        />
      )}

      {showDetailModal && (
        <PayDetailModal
          setShowDetailModal={setShowDetailModal}
          singlePayment={singlePayment}
        />
      )}

      {showFileModal && (
        <GenerateFileModal setShowFileModal={setShowFileModal} />
      )}

      {payments ? (
        <PaymentsList
          payments={payments}
          setShowDetailModal={setShowDetailModal}
          setSinglePayment={setSinglePayment}
        />
      ) : (
        <div className='loader animate-spin mx-auto mt-20 mb-20'></div>
      )}

      <div className='grid grid-cols-2'>
        {previous ? (
          <button
            className='bg-viper justify-self-center text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3'
            onClick={previousPage}>
            Anterior
          </button>
        ) : (
          <button
            className='bg-gray-400 justify-self-center text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3'
            disabled>
            Anterior
          </button>
        )}

        {next ? (
          <button
            className='bg-viper justify-self-center  text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3 ml-7'
            onClick={nextPage}>
            <span>Siguiente</span>
          </button>
        ) : (
          <button
            className='bg-gray-400 justify-self-center  text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3 ml-7'
            disabled>
            <span>Siguiente</span>
          </button>
        )}
      </div>
    </>
  )
}

export default Payments
